import type { CSSProperties } from "react";

// Two-letter initials from a name; "?" when empty. Shared so every avatar
// fallback derives them identically.
export function avatarInitials(name: string | null | undefined): string {
  return (
    (name ?? "")
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((s) => s[0]?.toUpperCase() ?? "")
      .join("") || "?"
  );
}

// The single placeholder look across the app: a warm gold sphere with cream
// initials, taken from the profile avatar. One source of truth so every
// fallback avatar (chat, search, contacts, pins, match, …) reads identically.
// Pair with `font-serif` and a `rounded-full` box; size/text come from the
// call site.
export const AVATAR_PLACEHOLDER_STYLE: CSSProperties = {
  background:
    "radial-gradient(circle at 35% 30%, #c8a577, transparent 55%), radial-gradient(circle at 70% 70%, #6b4f30, transparent 60%), linear-gradient(135deg, #a98666, #6e4f31)",
  color: "#fbeed1",
};
